import React, { Component } from 'react';

import theme from '../../app.theme';

class ProgressBar extends Component {
  render() {
    const palette = theme.palette;
    const fillColor = (this.props.progress >= 1) ? palette.fullProgressbarColor : palette.progressBgColor

    return (
      <div style={Object.assign(styles.progressBar, this.props.style)}>
        <div style={{height: 2, bottom: 0, width: (this.props.progress * 100)+'%', backgroundColor: fillColor }} />
      </div>
    );
  }
}

const styles = {
  progressBar:{
    backgroundColor: theme.palette.noProgressBgColor,
    height: 2,
    width: '100%',
    overflow: 'hidden'
  },
};


export default ProgressBar;



// WEBPACK FOOTER //
// ./src/app/components/progressbar/progressbar.js